import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';
import Custombutton from '../components/Custombutton';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p
                className="about__subheading"
                data-aos="fade-in"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
              >
                Hi, I am{' '}
                <span
                  data-aos="fade-in"
                  data-aos-anchor-placement="top-bottom"
                  data-aos-duration="700"
                >
                  Abdul Aziz
                </span>
              </p>
              <h2
                className="about__heading"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
              >
                A Web developer & Web Designer
              </h2>
              <div className="about__info">
                <PText data-aos="fade-right">
                  I am from Bangalore, India. A place of beauty,nature and
                  techhub. Since my childhood, i love technology and designing.
                  I always try to design stuff with my unique point of view. I
                  also love to create things that can be usefull to others.
                  <br /> <br />
                  I started coding since I was in high school. Coding is also an
                  art for me. I love it and now I have the opportunity to design
                  along with the coding. I find it really interesting and I
                  enjoyed the process a lot.
                  <br />
                  <br />
                  My vision is to be at a Mastery Level no matter what I do. Now
                  almost everything is becoming better than ever. I have a
                  habbit of giving my 100% in things what i love the most
                </PText>
              </div>

              <Custombutton />
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1
                className="about__info__heading"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
              >
                Education
              </h1>

              <AboutInfoItem
                title="School"
                items={['Noble Boys. High School, Gulbarga']}
                data-aos="fade-right"
                data-aos-anchor="#example-anchor"
                data-aos-offset="500"
                data-aos-duration="500"
              />
              <AboutInfoItem
                title="College"
                items={['Shree Guru Independent PU College, Gulbarga']}
              />
              <AboutInfoItem
                title="Graduation"
                items={['Visvesvaraya Technological University,Belgaum']}
              />
            </div>
            <div className="about__info__item">
              <h1
                className="about__info__heading"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
              >
                My Skills
              </h1>

              <AboutInfoItem
                title="FrontEnd"
                items={[
                  'HTML',
                  'CSS',
                  'JS',
                  'REACT',
                  'Tailwind CSS',
                  'Bootstrap',
                ]}
              />
              <AboutInfoItem
                title="BackEnd"
                items={['Node', 'Express', 'Java']}
              />
              <AboutInfoItem
                title="Design"
                items={['Photoshop', 'Canva', 'Figma']}
              />
            </div>
            <div className="about__info__item">
              <h1
                className="about__info__heading"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-duration="700"
              >
                Experiences
              </h1>
              <br />
              <AboutInfoItem
                title="Jan 22 - Mar 22"
                items={[
                  'Intern at Structwel Designers & Consultants Pvt. Ltd. - Turbhe',
                ]}
              />
              <br /> <br />
              <AboutInfoItem
                title="Sep 22 - Dec 22"
                items={[
                  'Front end intern at Enteractive technology solutions bengaluru ',
                ]}
              />
              <br />
              <AboutInfoItem
                title="2019-present"
                items={['Freelance Graphic Designer']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
